import { WeavePopNotification } from '@frontend/types';

export const mockIncomingCallNotification = () =>
  ({
    id: Math.random().toString(),
    type: 'incoming-call',
    timestamp: new Date().toString(),
    location: 'Testville',
    payload: {
      callerName: 'Jon Hopkins',
      callerNumber: '1234567890',
      recipientLocationName: 'Happy Smiles Lehi',
    },
    state: {
      status: 'unread',
      paused: true,
      timeout: 0,
    },
  } satisfies WeavePopNotification);

export const mockNewMessageNotification = () =>
  ({
    id: Math.random().toString(),
    type: 'sms-message-new',
    // timestamp doesn't exist here on the real websocket event, so we need to add it
    timestamp: new Date().toString(),
    location: 'Testville',
    payload: {
      body: 'You have a new message from somebody from across the world and they are hoping to hear from you because they are a prince from the congo and they have a lot of money to give you',
      number: '1234567890',
      personId: '1234567890',
      threadId: '1234567890',
      departmentId: '1234567890',
      locationPhone: '+11234567890',
      locationId: '1234567890',
      firstName: 'James',
      lastName: 'Bond',
    },
    state: {
      status: 'unread',
      paused: false,
      timeout: 8000,
    },
    flags: {
      shouldAllowReply: false,
    },
  } satisfies WeavePopNotification);

//TODO: Voicemail is not yet added to the payload types
// const newVoicemail = {
//   id: Math.random().toString(),
//   type: 'new-voicemail',
//   status: 'unread',
//   timestamp: new Date().toString(),
//   location: 'Testville',
//   payload: {
//     transcription: 'Hello, this is Sara Johannesburg, calling to let you know I need to reschedule my appointment',
//     number: '1234567890',
//   },
// } satisfies Notification;

export const mockNewFaxNotification = () =>
  ({
    id: Math.random().toString(),
    type: 'fax-new',
    timestamp: new Date().toString(),
    location: 'Testville',
    payload: {
      faxId: '00000000-0000-0000-0000-000000000000',
      action: 'inbound',
      from: '1234567890',
      to: '1234567890',
    },
    state: {
      status: 'unread',
      paused: false,
      timeout: 8000,
    },
  } satisfies WeavePopNotification);

export const mockNewScheduleRequestNotification = () =>
  ({
    id: Math.random().toString(),
    type: 'schedule-request-new',
    timestamp: new Date().toString(),
    location: 'Testville',
    payload: {
      appointmentType: 'test',
      dateTime: new Date(Date.now() + Math.floor(Math.random() * 10 + 1) * 24 * 60 * 60 * 1000).toString(), // random day between 1 and 10 days from now
      id: Math.random().toString(),
      durationMinutes: 20,
      note: 'test',
      notificationType: 'ScheduleRequest',
      schedulee: { firstName: 'Elaine', lastName: 'Bennis' },
    },
    state: {
      status: 'unread',
      paused: false,
      timeout: 8000,
    },
  } satisfies WeavePopNotification);

export const mockScheduleWaitlistNotification = () =>
  ({
    id: Math.random().toString(),
    type: 'schedule-waitlist',
    timestamp: new Date().toString(),
    location: 'Testville',
    payload: {
      inviteeName: 'George Costanza',
      inviteePersonId: 'george-person-id-1234',
      locationId: '000-0000-0000-0000-000000000000',
      appointmentId: '000-0000-0000-0000-000000000000',
      startTime: new Date(Date.now() + Math.floor(Math.random() * 10 + 1) * 24 * 60 * 60 * 1000).toString(), // random day between 1 and 10 days from now
      endTime: new Date(
        Date.now() + Math.floor(Math.random() * 10 + 1) * 24 * 60 * 60 * 1000 + 30 * 60 * 1000
      ).toString(), // random day between 1 and 10 days from now plus 30 minutes
      status: 'BOOKED',
    },
    state: {
      status: 'unread',
      paused: false,
      timeout: 8000,
    },
  } satisfies WeavePopNotification);

export const mockNewFollowupNotification = () =>
  ({
    id: Math.random().toString(),
    type: 'message-followup',
    timestamp: new Date().toString(),
    location: 'Testville',
    payload: {
      method: 'call',
      patient: {
        id: 'John Hopkins',
        email: 'jon@hopkins.com',
        phone_number: '1234567890',
        first_name: 'Jon',
        last_name: 'Hopkins',
      },
      text: 'Test`        ',
    },
    state: {
      status: 'unread',
      paused: false,
      timeout: 8000,
    },
  } satisfies WeavePopNotification);

export const mockNewReviewNotification = () =>
  ({
    id: Math.random().toString(),
    type: 'review-new',
    timestamp: new Date().toString(),
    location: 'Testville',
    payload: {
      title: 'New review title',
      body: 'New review body',
      siteName: 'private',
      author: 'Jerry Seinfeld',
      reviewId: 'ZWI2OWM0YmYtYWUyNi00N2U1LTg3YzgtZjc5N2YzY2IxYzI5',
      rating: 0,
      recommendationType: 'none',
    },
    state: {
      status: 'unread',
      paused: false,
      timeout: 8000,
    },
  } satisfies WeavePopNotification);

export const mockIncomingChatNotification = () =>
  ({
    id: Math.random().toString(),
    type: 'chat-message-new',
    timestamp: new Date().toString(),
    location: 'Testville',
    payload: {
      authorName: 'Cosmo Kramer',
      message: 'Test message',
      channelId: '123',
      isMention: false,
      reaction: null,
      attachments: null,
    },
    state: {
      status: 'unread',
      paused: false,
      timeout: 8000,
    },
  } satisfies WeavePopNotification);

export const mockFormSubmissionNewNotification = () =>
  ({
    id: Math.random().toString(),
    type: 'form-submission-new',
    timestamp: new Date().toString(),
    location: 'New york city dental',
    payload: {
      firstName: 'Jerry',
      lastName: 'Seinfeld',
      submissionId: '123',
      documentName: 'on',
      submittedAt: new Date().toLocaleDateString(),
    },
    state: {
      status: 'unread',
      paused: false,
      timeout: 8000,
    },
  } satisfies WeavePopNotification);

export const mockSmsTagNewNotification = () =>
  ({
    id: Math.random().toString(),
    type: 'sms-tag',
    timestamp: new Date().toString(),
    location: 'Testville',
    payload: {
      action: 'tagApplied',
      tagId: 'cbc96ba1-1827-4f77-a640-1680c3d4596b',
      tagName: 'Example Tag',
      title: 'A message has been tagged',
      tagColor: 'blue',
      userId: '29538c84-f2ab-4d76-9a25-064ab1b935af',
      smsId: '18f4256f-0267-4555-ba00-23c111710587',
      threadId: '92b16357-47e3-5ecb-a3e6-b733f407d158',
      smsCreatedAt: '2024-08-29T17:25:31Z',
      personFirstName: 'John',
      personLastName: 'Doe',
      personPreferredName: '',
      personPhone: '+18015551234',
      personId: '947c9396-a19c-522e-a7b3-2f6f598e1bcb',
      assignedUserIds: [
        '793bbc15-7d60-4271-9633-ddd47e2c6c78',
        '39021c0c-2ffe-4074-8a73-c0a0c1b3ae70',
        '9ad03afc-47e4-4f17-b7c0-e025086323e2',
        '6f663faf-51f0-4711-aad6-a631a0111bb0',
      ],
      groupId: '38fd93c3-78d0-4ef4-9466-99421eccf600',
      numMedia: 0,
      smsBody: 'This is the message that was tagged',
    },
    state: {
      status: 'unread',
      paused: false,
      timeout: 8000,
    },
  } satisfies WeavePopNotification);

export const mockPaymentsNotification = () =>
  ({
    id: Math.random().toString(),
    type: 'payments',
    timestamp: new Date().toString(),
    location: 'Payments-Express',
    payload: {
      invoiceId: '3d0a2fd5-c659-45e7-95cd-07b3f618b93b',
      origin: 'Manual Card Entry',
      patientName: 'Jerry Seinfeld',
    },
    state: {
      status: 'unread',
      paused: false,
      timeout: 8000,
    },
  } satisfies WeavePopNotification);

export const notificationMocks = [
  mockIncomingCallNotification(),
  mockNewMessageNotification(),
  mockNewFaxNotification(),
  mockNewScheduleRequestNotification(),
  mockScheduleWaitlistNotification(),
  mockNewFollowupNotification(),
  mockSmsTagNewNotification(),
  mockIncomingChatNotification(),
  mockFormSubmissionNewNotification(),
  mockNewReviewNotification(),
  mockPaymentsNotification(),
];
